import { useEffect } from "react"

export const useEscapeKey = (onKeyBoard: () => void) => {
  useEffect(() => {
    const handleKeyBoard = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onKeyBoard()
      }
    }

    document.addEventListener("keydown", handleKeyBoard)

    return () => {
      document.removeEventListener("keydown", handleKeyBoard)
    }
  }, [onKeyBoard])
}
